import React from 'react';
import ManagedDisclaimer from './ManagedDisclaimer';

const TermsModal = ({ show, onClose }) => {
  if (!show) return null;

  return (
    <div
      className="modal-backdrop-custom"
      onClick={onClose}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px'
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          backgroundColor: '#fff',
          borderRadius: '12px',
          width: '100%',
          maxWidth: '800px',
          maxHeight: '85vh',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
        }}
      >
        {/* Header */}
        <div style={{
          padding: '24px 28px 16px',
          borderBottom: '2px solid var(--secondary-color, #f0a500)',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexShrink: 0
        }}>
          <h4 style={{
            margin: 0,
            color: 'var(--primary-color, #072040)',
            fontWeight: 700,
            fontSize: '1.3rem'
          }}>
            Disclaimer &amp; Terms of Use
          </h4>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '1.5rem',
              cursor: 'pointer',
              color: 'var(--gray-color, #6c757d)',
              padding: '0 4px',
              lineHeight: 1
            }}
            aria-label="Close"
          >
            &times;
          </button>
        </div>

        {/* Scrollable Content */}
        <div style={{
          padding: '24px 28px',
          overflowY: 'auto',
          flex: 1,
          color: 'var(--dark-color, #212529)',
          fontSize: '0.9rem',
          lineHeight: 1.7
        }}>
          <style>{`
            .terms-content h5 { color: var(--primary-color, #072040); font-weight: 700; margin: 0 0 12px; font-size: 1.05rem; }
            .terms-content h5:not(:first-child) { margin-top: 28px; }
            .terms-content ol, .terms-content ul { padding-left: 24px; margin-bottom: 12px; }
          `}</style>
          {/* Text managed in Admin > Disclaimers (portal_terms) */}
          <ManagedDisclaimer dkey="portal_terms" className="terms-content" />
        </div>

        {/* Footer */}
        <div style={{
          padding: '16px 28px',
          borderTop: '1px solid rgba(0, 0, 0, 0.1)',
          textAlign: 'right',
          flexShrink: 0
        }}>
          <button
            onClick={onClose}
            style={{
              backgroundColor: 'var(--primary-color, #072040)',
              color: '#fff',
              border: 'none',
              borderRadius: '8px',
              padding: '10px 28px',
              fontWeight: 600,
              cursor: 'pointer',
              fontSize: '0.9rem'
            }}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;
